/**
 * Pure GST Calculation and normalization helpers
 */

export function normalizeDate(dateInput) {
  if (!dateInput) return "";
  if (typeof dateInput === "string") {
    const trimmed = dateInput.trim();
    if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) return trimmed;
    if (/^\d{2}-\d{2}-\d{4}$/.test(trimmed)) {
      const [d, m, y] = trimmed.split("-");
      return `${y}-${m}-${d}`;
    }
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(trimmed)) {
      const [d, m, y] = trimmed.split("/");
      return `${y}-${m}-${d}`;
    }
    const parsed = new Date(trimmed);
    if (!isNaN(parsed.getTime())) {
      return parsed.toISOString().slice(0, 10);
    }
  } else if (dateInput && typeof dateInput.toDate === "function") {
    return dateInput.toDate().toISOString().slice(0, 10);
  } else if (dateInput && dateInput.seconds !== undefined) {
    return new Date(dateInput.seconds * 1000).toISOString().slice(0, 10);
  } else if (dateInput instanceof Date && !isNaN(dateInput.getTime())) {
    return dateInput.toISOString().slice(0, 10);
  }
  return "";
}

export function computeNetTax(totalOutput, totalItc) {
  const netCgst = Math.max(0, Math.round((totalOutput.cgst - totalItc.cgst) * 100) / 100);
  const netSgst = Math.max(0, Math.round((totalOutput.sgst - totalItc.sgst) * 100) / 100);
  const netIgst = Math.max(0, Math.round((totalOutput.igst - totalItc.igst) * 100) / 100);
  const total = netCgst + netSgst + netIgst;

  return { cgst: netCgst, sgst: netSgst, igst: netIgst, total };
}
